"use client";

import { c as _c } from "react/compiler-runtime";
import { IconShoppingCart, IconX } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useCart } from "@/queries/useCart";
import { useNewCartStore } from "@/stores/useNewCartStore";
import { FreeShippingCelebration } from "./FreeShippingCelebration";
import { FreeShippingTracker } from "./FreeShippingTracker";
export function CartSidebarHeader() {
  const $ = _c(21);
  const {
    data: cart,
    isPending
  } = useCart();
  const setIsCartOpen = useNewCartStore(_temp);
  const itemCount = cart?.items?.length ?? 0;
  const isFreeShipping = cart?.freeShippingInfo?.freeShippingPricePercentage === 100;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconShoppingCart className="size-6" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isPending) {
    t1 = isPending && <Skeleton className="absolute -top-1 -right-1.5 size-4 rounded-full border border-white bg-neutral-200" data-testid="cart-item-count-skeleton" />;
    $[1] = isPending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isPending || $[4] !== itemCount) {
    t2 = !isPending && itemCount > 0 && <span className="absolute -top-1 -right-1.5 flex size-4 items-center justify-center rounded-full border border-white bg-primary text-[9px] font-bold text-primary-foreground" data-testid="cart-item-count">{itemCount}</span>;
    $[3] = isPending;
    $[4] = itemCount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="relative shrink-0" data-testid="cart-header-icon">{t0}{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isFreeShipping || $[10] !== itemCount) {
    t4 = itemCount > 0 && (isFreeShipping ? <FreeShippingCelebration /> : <FreeShippingTracker />);
    $[9] = isFreeShipping;
    $[10] = itemCount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== setIsCartOpen) {
    t5 = () => setIsCartOpen(false);
    $[12] = setIsCartOpen;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconX className="size-5" />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5) {
    t7 = <Button variant="ghost" size="icon-sm" className="shrink-0" onClick={t5} aria-label="Close cart" data-cart-close-button="">{t6}</Button>;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
    t8 = <div className="flex h-[72px] items-center justify-between gap-4 border-b border-border px-4" data-testid="cart-header">{t3}{t4}{t7}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(state) {
  return state.setIsCartOpen;
}